import React from 'react'

export interface BackgroundBoxProps {
  children: React.ReactNode
  className?: string
}

/**
 * BackgroundBox Component
 *
 * A container component with Heritage Blue 40% background and white 4% border.
 * Used for creating consistent background containers throughout the design system.
 *
 * @param children - Content to be rendered inside the box
 * @param className - Additional CSS classes to apply
 */
export const BackgroundBox: React.FC<BackgroundBoxProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`
        bg-heritage-blue-40 
        border border-white-20 
        rounded-lg 
        p-6 
        ${className}
      `}
    >
      {children}
    </div>
  )
}

export default BackgroundBox
